export interface MembershipSaveOfferTemplate {
  type?: unknown;
  value?: unknown;
}

export function normalizeMembershipCreditAmount(value: unknown): number | undefined {
  if (typeof value !== 'number' || !Number.isFinite(value)) return undefined;

  const scaled = Math.abs(value) * 100;
  const lowerCent = Math.floor(scaled);
  const fraction = scaled - lowerCent;
  const tieTolerance = Number.EPSILON * Math.max(1, scaled) * 4;
  const cents =
    Math.abs(fraction - 0.5) <= tieTolerance
      ? lowerCent % 2 === 0
        ? lowerCent
        : lowerCent + 1
      : Math.round(scaled);
  const rounded = cents / 100;
  return rounded > 0 ? rounded : undefined;
}

export function membershipSaveOfferAmount(offer: MembershipSaveOfferTemplate): number | undefined {
  return offer.type === 'CREDIT' ? normalizeMembershipCreditAmount(offer.value) : undefined;
}

export function isRenderableMembershipSaveOffer(offer: MembershipSaveOfferTemplate): boolean {
  return (
    offer.type === 'FREE_MONTH' ||
    (offer.type === 'CREDIT' && membershipSaveOfferAmount(offer) != null)
  );
}
